import React from 'react'

import './Button.css'

function Button(props) {
  return (
    <>
  
        <button className="name noselect buttonsss"> {props.title}</button>
       
  
    </>
  )
}

export default Button
